import styled from 'styled-components';
import { baseContainer } from '@redsift/design-system';
import { StyledDialogContentBodyProps } from './types';

/**
 * Component style.
 */
export const StyledDialogContentBody = styled.div<StyledDialogContentBodyProps>`
  ${baseContainer}

  overflow-y: auto;
  max-height: ${({ $maxHeight }) => $maxHeight};

  font-family: var(--redsift-typography-body-font-family);
  font-size: var(--redsift-typography-body-font-size);
  font-weight: var(--redsift-typography-body-font-weight);
  line-height: var(--redsift-typography-body-line-height);
  padding: 0 24px;
  margin: 16px -24px;

  &:focus-visible {
    outline: none;
  }

  scrollbar-color: var(--redsift-color-neutral-mid-grey) transparent;
  scrollbar-width: thin;

  &::-webkit-scrollbar {
    block-size: 9px;
    inline-size: 9px;
  }

  &::-webkit-scrollbar-thumb {
    background-clip: padding-box;
    background-color: var(--redsift-color-neutral-mid-grey);
    border-radius: 0px;
    border-left: 2px solid transparent;
    border-right: 2px solid transparent;
  }

  &::-webkit-scrollbar-track {
    background-color: transparent;
  }

  &::-webkit-scrollbar-thumb:horizontal,
  &::-webkit-scrollbar-thumb:vertical {
    &:hover {
      background-color: var(--redsift-color-neutral-x-dark-grey);
    }
  }

  &::-webkit-scrollbar-corner {
    visibility: hidden;
  }
`;
